export const topicLinks = [
  {
    header: 'Explore',
    links: [
      {
        text: 'How it works',
        url: 'https://www.fundera.com/how-it-works',
      },
      {
        text: 'About',
        url: 'https://www.fundera.com/about',
      },
      {
        text: 'Testimonials',
        url: 'https://www.fundera.com/testimonials',
      },
      {
        text: 'Careers',
        url: 'https://www.nerdwallet.com/careers?trk=fundera',
      },
      {
        text: 'Newsroom',
        url: 'https://www.fundera.com/about/newsroom',
      },
    ],
  },
  {
    header: 'Need Help?',
    links: [
      {
        text: 'support@fundera.com',
        url: 'mailto:support@fundera.com',
      },
    ],
  },
  {
    header: 'Resources',
    links: [
      {
        text: 'Small Business Loans',
        url: 'https://www.fundera.com/business-loans',
      },
      {
        text: 'Business Bank Accounts',
        url: 'https://www.fundera.com/business-bank-accounts',
      },
      {
        text: 'HR & Payroll',
        url: 'https://www.fundera.com/blog/hr-for-small-business',
      },
      {
        text: 'Accounting',
        url: 'https://www.fundera.com/business-accounting',
      },
      {
        text: 'Blog',
        url: 'https://www.fundera.com/blog',
      },
    ],
  },
];

export const bottomLinks = [
  {
    text: 'Privacy Policy',
    url: 'https://www.fundera.com/privacy',
  },
  {
    text: 'Terms of Service',
    url: 'https://www.fundera.com/tos',
  },
  {
    text: 'California Privacy Policy',
    url: 'https://www.nerdwallet.com/blog/nerdwallet-california-privacy-policy',
  },
  {
    text: 'Do not sell my personal information',
    url: 'https://www.nerdwallet.com/blog/nerdwallet-california-privacy-policy/#opt_out',
  },
  {
    text: 'Privacy Preferences',
    url: 'https://privacyportal.onetrust.com/webform/694a76f6-1f82-455e-b46e-ffeed902c3fa/6505b804-0b41-462a-9417-9d71960b39ac',
  },
  {
    text: 'Licenses and Disclosures',
    url: 'https://www.fundera.com/licenses-disclosures',
  },
  {
    type: 'spacer',
  },
  {
    text: 'All Rights Reserved',
  },
];
